const buildOptimizationListFromFlat = (item) => {
    const optimizations = [];

    if (item?.optimizationCalculationId != null) {
        optimizations.push({
            id: item.optimizationCalculationId,
            number: item.optimizationCalculationName,
        });
    }

    if (item?.optimizationWorkId != null) {
        optimizations.push({
            id: item.optimizationWorkId,
            number: item.optimizationWorkName,
        });
    }

    return optimizations;
};

const buildWorkingCuttingMapListFromFlat = (item) => {
    const maps = [];

    if (item?.calWorkingCuttingMapId != null) {
        maps.push({
            id: item.calWorkingCuttingMapId,
            number: item.calWorkingCuttingMapName,
        });
    }

    if (item?.workingCuttingMapId != null) {
        maps.push({
            id: item.workingCuttingMapId,
            number: item.workingCuttingMapName,
        });
    }

    return maps;
};

export const getRequestsCuttingPlanId = (row) =>
    row?.planId ?? row?.plaId ?? row?.plan?.id ?? null;

export const getRequestsCuttingMaterialName = (row) =>
    row?.materialOrganizationOptionName ?? row?.materialOrganizationOption?.name ?? '';

export const getRequestsCuttingOrderNumber = (row) =>
    row?.orderNumber ?? row?.order?.number ?? null;

export const getRequestsCuttingWorkingCuttingMapId = (row) =>
    row?.workingCuttingMapId ?? row?.workingCuttingMap?.id ?? null;

export const getRequestsCuttingWorkingCuttingMapName = (row) =>
    row?.workingCuttingMapName ?? row?.workingCuttingMap?.number ?? null;

export const getRequestsCuttingMaterialOrganizationOptionId = (row) =>
    row?.materialOrganizationOptionId ?? row?.materialOrganizationOption?.id ?? row?.materialOId ?? null;

export const getRequestsCuttingPlanName = (row) =>
    row?.planName ?? row?.plan?.name ?? null;

/** [0] — расчётная, [1] — рабочая. */
export const getRequestsCuttingOptimizations = (row) => {
    if (Array.isArray(row?.optimization) && row.optimization.length > 0) {
        return row.optimization.filter((item) => item != null);
    }

    return buildOptimizationListFromFlat(row);
};

/** [0] — расчётная, [1] — рабочая. */
export const getRequestsCuttingWorkingCuttingMaps = (row) => {
    if (Array.isArray(row?.workingCuttingMaps) && row.workingCuttingMaps.length > 0) {
        return row.workingCuttingMaps.filter((item) => item != null);
    }

    const fromFlat = buildWorkingCuttingMapListFromFlat(row);
    if (fromFlat.length > 0) {
        return fromFlat;
    }

    const workMapId = getRequestsCuttingWorkingCuttingMapId(row);
    const workMapName = getRequestsCuttingWorkingCuttingMapName(row);
    if (workMapId != null) {
        return [{id: workMapId, number: workMapName}];
    }

    return [];
};

/** Нормализует строку: плоские поля доступны всегда, в т.ч. после чтения legacy-ответов. */
export const enrichRequestsCuttingRow = (row) => {
    if (!row) {
        return row;
    }

    const optimizations = getRequestsCuttingOptimizations(row);
    const workingCuttingMaps = getRequestsCuttingWorkingCuttingMaps(row);

    const materialName = row.materialName ?? getRequestsCuttingMaterialName(row);
    const thickness = row.thickness ?? row.materialOrganizationOption?.thickness ?? null;
    const materialId = row.materialId ?? row.materialOrganizationOption?.materialId ?? null;

    return {
        ...row,
        materialName,
        thickness,
        materialId,
        materialOrganizationOptionName: row.materialOrganizationOptionName ?? materialName,
        materialOrganizationOptionId:
            row.materialOrganizationOptionId ?? row.materialOId ?? getRequestsCuttingMaterialOrganizationOptionId(row),
        orderNumber: row.orderNumber ?? getRequestsCuttingOrderNumber(row),
        workingCuttingMapId: row.workingCuttingMapId ?? getRequestsCuttingWorkingCuttingMapId(row),
        workingCuttingMapName: row.workingCuttingMapName ?? getRequestsCuttingWorkingCuttingMapName(row),
        planId: row.planId ?? row.plaId ?? getRequestsCuttingPlanId(row),
        planName: row.planName ?? getRequestsCuttingPlanName(row),
        optimizationDisplay: optimizations.map((opt) => opt.number).filter(Boolean).join(' / '),
        workingCuttingMapDisplay: workingCuttingMaps.map((map) => map.number).filter(Boolean).join(' / '),
    };
};

export const enrichRequestsCuttingRows = (rows) =>
    (rows ?? []).map(enrichRequestsCuttingRow);

export const mapNotArchiveRequestsCuttingList = enrichRequestsCuttingRows;

export const buildWorkingCuttingMapLinkPath = (row, {isCloud = false, mapId, mapNumber} = {}) => {
    const resolvedMapId = mapId ?? getRequestsCuttingWorkingCuttingMapId(row);
    const resolvedMapNumber = mapNumber ?? getRequestsCuttingWorkingCuttingMapName(row);
    const materialName = getRequestsCuttingMaterialName(row);
    const materialOId = getRequestsCuttingMaterialOrganizationOptionId(row);

    if (resolvedMapId == null || !resolvedMapNumber || materialOId == null) {
        return null;
    }

    return `/organization/working-cutting-map/${resolvedMapId}/${encodeURIComponent(materialName)}/${encodeURIComponent(resolvedMapNumber)}/${materialOId}${isCloud ? '/cloud' : ''}`;
};
